import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {

  preferences: Array<[]> = []
  selectedPref: Array<[]> = []
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PreferencesComponent>
  ) { }

  ngOnInit() {
    console.log("Here the data of preferences", this.data);
    this.preferences = this.data.preferences
    this.selectedPref = this.preferences.filter((x: any) => { if (x.value) return x.key })
    console.log("After the filter", this.selectedPref);

  }



  // UTILITY

  changePreferences() {
    console.log("Here the selected preferences", this.preferences);

  }

  actionApply() {
    this.dialogRef.close(this.preferences)
  }
  cancel() {
    this.dialogRef.close()
  }

}
